import isPdf from './isPdf';
import isPDFPreviewSupported from './isPDFPreviewSupported';
import { getAttachmentPolicyInfoForPublicComputer } from 'owa-attachment-policy';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default function shouldPreviewNativeViewableDocument(
    attachment: AttachmentType,
    isCloudy: boolean
): boolean {
    if (isPdf(attachment) && isPDFPreviewSupported()) {
        if (isCloudy) {
            return true;
        } else {
            const policyInfo = getAttachmentPolicyInfoForPublicComputer(
                attachment,
                true /* isWacPreviewSupportedOnPlatform */
            );
            return policyInfo.directFileAccessEnabled;
        }
    }

    return false;
}
